var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTtTerminalTractor = function SvgTtTerminalTractor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.2 46.2H98M49.9 63.2H10.3l4.9-32c.4-2.8 2.8-4.8 5.6-4.8h26.3c1.6 0 2.8 1.3 2.8 2.8v34ZM89.6 46.2l-17 17M30.1 85.9c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5 3.8 8.5 8.5 8.5ZM89.6 85.9c4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5 3.8 8.5 8.5 8.5Z",
    stroke: "#2C112D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9 26.4v19.8c0 1.6-1.3 2.8-2.8 2.8h-17M38.6 77.4h42.5M98.1 77.4h8.5V66.1l-11.3-2.8H7.4v14.2h14.2",
    stroke: "#2C112D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTtTerminalTractor;